import Address from "./Address";
import {Expose} from "class-transformer";

export default class User extends Address {
    email: string;

    email_confirm: string;

    password: string;

    @Expose({name: "sign_in_count"})
    signInCount: number

    name: string;

    @Expose({name: "first_name"})
    firstName: string;

    @Expose({name: "last_name"})
    lastName: string;

    @Expose({name: "full_name"})
    fullName: string;

    @Expose({name: "is_professional"})
    isProfessional: boolean;

    @Expose({name: "is_owner"})
    isOwner: boolean;
    profession: string;
    bio: string;
    phone: string;
    sex: string;
    @Expose({name: "country_code"})
    countryCode: string;

    @Expose({name: "profile_picture_url"})
    profilePictureUrl: string;

    @Expose({name: "is_followed"})
    isFollowed: boolean;

    @Expose({name: "followers_count"})
    followersCount: number;

    @Expose({name: "following_count"})
    followingCount: number;

    @Expose({name: "users_followed_count"})
    usersfollowingCount: number;

    @Expose({name: "default_followable"})
    defaultFollowable: boolean;

    username(): string {
        return '@' + this.name;
    }

    gender(): string {
        if (this.sex == 'male')
            return 'Male';
        else if (this.sex == 'female')
            return 'Female';
        return '';
    }

    displayProfession(): string {
        if (this.profession === undefined || this.profession === " ")
            return "Styleteq User";
        return this.profession;
    }

    @Expose({name: "address_1"})
    street1;
    @Expose({name: "address_2"})
    street2;

    profilePicture(): string {
        if (this.profilePictureUrl == 'user_default.jpg')
            return window.Styleteq.images.userDefault;
        else
            return this.profilePictureUrl;
    }

    phoneNumber(): string {
        return this.phone && this.countryCode ? this.countryCode + ' ' + this.phone : '';
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/User.ts